import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-operating-mode-indicators',
  templateUrl: './operating-mode-indicators.component.html',
  styleUrls: ['./operating-mode-indicators.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperatingModeIndicatorsComponent {}
